<template>
  <div class='m-b-20 s_flex_ali'>
    <a-button type="primary" v-has:marketingSmsAdd="()=>{$router.push('/messageCenter/sms/createTemplate')}">创建模板</a-button>
    <a-button class='m-l-20' type="primary" v-has:marketingSmsLog="()=>{auditShow=true}">审核记录</a-button>
  </div>
  <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" layout='inline'>
    <a-form-item label="关键词" name='keyword'>
      <a-input v-model:value="search.keyword" style="width: 300px;" placeholder="请输入模版名称/内容进行搜索" />
    </a-form-item>
    <a-form-item label="来源" name='type'>
      <a-select v-model:value="search.type" :style="{width:'140px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option :value="1">系统提供</a-select-option>
        <a-select-option :value="2">自定义</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="状态" name='status'>
      <a-select v-model:value="search.status" :style="{width:'140px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option :value="1">启用</a-select-option>
        <a-select-option :value="0">禁用</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" @click='searchTable'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='name' :columns='columns' :data-source='data'>
    <template v-slot:actions="{ record }">
      <a-button type="primary" size="small" v-has:marketingSmsStatus="()=>status(record)"> {{record.status?'禁用':'启用'}}</a-button>
      <a-button type="danger" size="small" class="m-l-10" :disabled="record.status"  v-has:marketingSmsDel="()=>del(record)"> 删除</a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
  <a-modal :keyboard="false" title="审核记录" :width='1300' centered v-model:visible="auditShow" destroyOnClose :footer="null">
    <auditRecord></auditRecord>
  </a-modal>
</template>
<script>
  import { inject, reactive, ref, toRefs } from "vue";
  import {getSmsTemplate,getSmsStatus,templateDel} from "@/api/message.js";
  import { iscode } from "@/utils/app";
  import { message } from "ant-design-vue";
  import auditRecord from './auditRecord.vue'
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 10,
    type: "",
    keyword: "",
    status:""
  };
  export default {
    components: {
      auditRecord
    },
    setup() {
      let columns = [
        {
          title: "模板名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "模板内容",
          dataIndex: "content",
          key: "content",
        },
        {
          title: "状态",
          dataIndex: "status",
          key: "status",
          customRender:({record})=>{
            return record.status?'启用':'禁用'
          },
          width:100
        },
        {
          title: "操作",
          key: "actions",
          width:170,
          slots: { customRender: "actions" },
        },
      ];

      const state = reactive({
        auditShow:false
      });
      
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      let listLoading = ref(false);
      let data = ref([]);
      let total = ref(0);
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const initData = async (values) => {
        listLoading.value = true;
        let res = await getSmsTemplate(values).then((res) => res.data);
        listLoading.value = false;
        data.value = res.data.data;
        total.value = res.data.total;
      };
      initData(search.value);
      const searchTable = () => {
        search.value.page = 1
        initData(search.value);
      }
      const $Modal = inject("$Modal");
      //禁用
      const status = async (data) => {
        $Modal.confirm({
          centered: true,
          content: data.status ? "确定禁用当前模板吗，禁用后群发是不能选用该模板":"确定启用当前模板吗，启用后群发可选用该模板",
          onOk: async () => {
            let result = await getSmsStatus({ id: data.id, status: data.status ? 0 : 1 }).then(res => res.data).catch(error => error)
            if (iscode(result, true)) {
              initData(search.value);
            }
          },
        });
      }
      //删除
      const del = async (data) => {
        $Modal.confirm({
          centered: true,
          content: "删除后不可恢复，确定删除当前模板吗？",
          onOk: async () => {
            let result = await templateDel(data.id).then(res => res.data).catch(error => error)
            if (iscode(result, true)) {
              initData(search.value);
            }
          },
        });
      }
      return {
        columns,
        listLoading,
        pageSizeChange,
        pageCurrentChange,
        search,
        data,
        total,
        ...toRefs(state),
        searchTable,
        status,
        del
      };
    },
  };
</script>